/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_invite_page_invited_as = /** @type {(inputs: {}) => string} */ () => {
	return `Invitado como:`
};

const en_invite_page_invited_as = /** @type {(inputs: {}) => string} */ () => {
	return `Invited as:`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const invite_page_invited_as = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.invite_page_invited_as(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("invite_page_invited_as", locale)
	if (locale === "es") return es_invite_page_invited_as(inputs)
	return en_invite_page_invited_as(inputs)
};
export { invite_page_invited_as as "invite.page.invited_as" }